<template lang="pug">
div.padding
    el-row(:gutter="20")
      el-col(:span="24")
        shape-conflito(:id="id")
</template>

<script>
import ShapeConflito from './ShapeConflito.vue'

export default {
  components: {
    ShapeConflito
  },

  props: {
    id: {
      type: String,
      required: false
    }
  }

}
</script>

<style lang="scss" scoped>
.padding {
  padding: 20px;
}
</style>



// WEBPACK FOOTER //
// src/screens/central/comunicacao/ConflitosShape.vue